import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './Logout.css'

class Logout extends Component {
    constructor(props){
        super(props);
        this.state={

        }
        this.cancel=this.cancel.bind(this)
        this.sure=this.sure.bind(this)
    }

    cancel(){
        this.props.logoutF()
    }
    sure(){
        this.props.logoutF()
        window.localStorage.token=''
        window.localStorage.userId = ''
        this.props.push('/')
    }

    render() {
        return (
            <div className="logout">
                <div className="logout-container">
                    <div className="logout-title">
                        大赛提示
                    </div>
                    <div className="logout-question">
                        确定要退出登录吗?
                    </div>
                    <div className="logout-button">
                        <div className="logout-cancel" onClick={this.cancel}>取消</div>
                        <div className="logout-sure" onClick={this.sure}>确认</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Logout;